import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Idle } from '@ng-idle/core';
import * as CryptoJS from 'crypto-js';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../../shared/config/app-config';
import { SessiontempComponent } from '../../sessiontemp/sessiontemp.component';
import { Puser, User } from '../models';
import { ApiService } from './api.service';
import { JwtService } from './jwt.service';
import { MyserviceService } from './session.service';
import { distinctUntilChanged } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class UserService {

  ipaddress: any;
  ip1: any;
  ip2: any;
  getPprofile: any;
  fromDate:Date;
  toDate:string;
  public currentUserSubject = new BehaviorSubject<User>(new User());
  public currentUser = this.currentUserSubject.asObservable().pipe(distinctUntilChanged());

  private PUserSubject = new BehaviorSubject<Puser>(new Puser());
  public PUser = this.PUserSubject.asObservable().pipe(distinctUntilChanged());

  private tempVarSubject = new BehaviorSubject<any>('');
  public tempVar = this.tempVarSubject.asObservable().pipe(distinctUntilChanged());

  private isAuthenticatedSubject = new ReplaySubject<boolean>(1);
  public isAuthenticated = this.isAuthenticatedSubject.asObservable();

  public langFileSubject = new BehaviorSubject<any>('');

  muliRoleEnter: boolean = false;
  resetPassvalue: boolean = false;
  selectedWorkFlowID: any = 0;
  outOfOfficeReason:any;
  LoginDefaultLanguage = 'en';
  cnDefaultLang: string = 'en';
  defaultLang: string = localStorage.getItem("selectedLanguage") && localStorage.getItem("selectedLanguage") != 'null'  ? localStorage.getItem("selectedLanguage") : "en";
  setDefaultLanugage = true;
  langChangedByUser = false;
  outOfOfficeStatus: any;
  selectedLang() {
    return localStorage.getItem("selectedLanguage") && localStorage.getItem("selectedLanguage") != 'null'  ? localStorage.getItem("selectedLanguage") : "en";
  }
  // defaultLang: string = "spa";

  translateText(text) {
    let transText = "";
    this.translate.get(text).subscribe(translatedText => {
      transText = translatedText;
    })
    return transText;
  }

  constructor(
    private router: Router,
    private apiService: ApiService,
    private jwtService: JwtService,
    private idle: Idle,
    public sessionService: MyserviceService,
    private toast: ToastrService,
    private dialog: MatDialog,
    private translate: TranslateService
  ) { 
    this.translate.setDefaultLang(this.defaultLang); 
  }

  // Verify JWT in localstorage with server & load user's info.
  // This runs once on application startup.
  populate() {
    // If JWT detected, attempt to get & store user's info
    window.localStorage.removeItem('session');
    let url = window.location.href.split("#");
    if (this.jwtService.getToken()) {
      let data = this.encrypt(JSON.stringify(window.localStorage['jwtToken']))
      this.apiService.post('/api/getsession', { data }).subscribe(
        data => {
          data = this.decrypt(data.data);
          if (data.item) {
            if (data.item.purl)
              window.localStorage['plogin'] = data.item.purl
            this.setPAuth(data);
          }
          else {
            this.purgeAuth()
            this.router.navigateByUrl('/login')
          }
        },
        err => {
          this.purgeAuth()
        }
      );
    }
    else {
      // Remove any potential remnants of previous auth states
      this.purgeAuth();
      let url = window.location.href;
      if (url.includes('/care') || url.includes('/patient') || url.includes('/admin')) {
        if (window.localStorage['plogin']) {
          this.router.navigateByUrl(`/plogin/${window.localStorage['plogin']}`)
        } else {
          this.router.navigateByUrl(`/login`)
        }
      }
    }
  }

  setmail(email) {
    this.jwtService.savemail(email)
  }

  updatetour(userAccountId) {
    return this.apiService.post('/api/updatewelcomeflag', { userAccountId })
      .map(data => {
        return data;
      });
  }
  getusersession() {
    let data: any = {
      patientSwfId: window.localStorage['Puser']
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/getusersession', { data })
      // .map(data => {
      //   return this.decrypt(data.data);
      // });
  }
  getsession() {
    let data = this.encrypt(JSON.stringify(window.localStorage['jwtToken']))
    return this.apiService.post('/api/getsession', { data })
      .map(data => {
        return this.decrypt(data.data);
      });
  }
  gethosp(userkey, curid) {
    let data: any = {
      "practiceId": userkey,
      "loginUaId": curid
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/reports/getHospitalList', { data })
      .map(data => this.decrypt(data.data));
  }
  getsurgeon(userkey) {
    let data = {
      "userAccountKey": userkey
    }
    return this.apiService.post('/api/v2/reports/getSurgeonList', data)
      .map(data => {
        return data;
      });
  }
  getDisList(userAccountKey) {
    let data: any = {
      "loginClientId": userAccountKey
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/reports/getDischargeTypeList', { data })
      .map(data => this.decrypt(data.data));
  }
  getinfo() {
    return this.apiService.post('/userinfo').map(data => data);
  }
  getuserdetails(userinfo) {
    let data = {
      'userName': userinfo
    }
    return this.apiService.post(`/api/v2/patient/getUserByEmailorPhone`, data)
      .map(data => {
        return data;
      });
  }
  getuserinfologin(email) {
    let data: any = {
      email: email
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/onboard/checkvalidation', { data })
      .map(data => this.decrypt(data.data));
  }
  postuserinfo(mode) {
    mode['patientSwfId'] = atob(window.localStorage['patSWFId'])['patSWFId']
    return this.apiService.post('/userinfo', { mode })
      .map(data => data);
  }
  postuserinfoid(mode, id) {
    let data: any = {
      "mode": mode,
      "userAccountId": id,
      "patientId": window.localStorage['patientId'] ? window.localStorage['patientId'] : 0,
      "patientSwfId": window.localStorage['Puser'] ? window.localStorage['Puser'] : 0
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/userinfo', { data })
      // .map(data => this.decrypt(data.data));
  }
  postsupport(patientId) {
    return this.apiService.post(`/api/v2/patient/updateSupportOnboardCardForPatient`, { patientId })
      .map(data => data);
  }

  goback(id, card) {
    let data = {
      "patientSwfId": id,
      "onboardCardName": card
    }
    return this.apiService.post(`/api/v2/onboard/disappearOnboardCard`, data)
      .map(data => data);
  }


  getPatientDetails(id) {
    let data: any = {
      "patientId": id
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/patient/findOnboardingCardsForPatient', { data })
      .map(data => this.decrypt(data.data))
  }
  menuuserinfo(mode, userAccountId) {  ///${userAccountId} userAccountId
    let data: any = {
      "userGroupId": mode,
      "userAccountId": userAccountId
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post(`/api/v2/patient/getUserGroupPrivelegeByGroupId`, { data })
      .map(arg => this.decrypt(arg.data));
  }
  msgcountPP(cid) {
    if (window.localStorage['Puser'] && cid && window.localStorage['jwtToken'])
      var data: any = {
        "patientSwfId": Number(window.localStorage['Puser']),
        "loginUaId": cid
      }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/commonctrl/api/getUnReadTotalMsgCountForPP', { data })
      .map(data => this.decrypt(data.data));
  }
  getrrep() {
    return this.apiService.get('/api/v2/reports/getpbireport').map(data => data);
  }
  logoutuser(userAccountId) {
    let data: any = {
      userAccountId: userAccountId
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/logout', { data }).subscribe(data => data);
  }
  // getslogout() {
  //   return this.apiService.sget('')
  //     .subscribe(data => data);
  // }
  getviewsurvey(surveyid) {
    let data: any = {
      "patientSurveyMappingId": surveyid,
      "pswfId": window.localStorage['Puser'],
      "oldResultId": 0
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/survey/getsurveyresult', { data })
      // .map(data => data);
  }
  getProfile(username) {
    let data: any = {
      "userName": username
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/profile/ccprofile', { data })
      .map(data => this.decrypt(data.data));
  }

  updateccprofile(profile) {
    let data = this.encrypt(JSON.stringify(profile));
    return this.apiService.post(`/api/v2/profile/updateCCProfile`, { data })
      .map(data => this.decrypt(data.data));
  }

  // phonebycountrycode(data) {
  //   return this.apiService
  //     .post('/api/v2/care/getphonebycountrycode/', data)
  //     .map(data => {
  //       return data;

  //     });
  // }

  getsurvey(surveyid, swfid, type) {
    let data: any = {
      "patientSurveyMappingId": surveyid,
      "pswfId": swfid,
      "mode": type
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/survey/getsurvey', { data })
      // .map(data => data);
  }
  // getslectedmenu(){
  //   return this.apiService.get('/api/v2/admin/menu/fetchMenuListByPatientId')
  //  .map(data => data);
  // }




  postsurvey(question, result, swfid, mode, type) {
    let surveyTakenBy = this.getCurrentUser().item.userAccountId
    if (window.localStorage['superClientId'])
      surveyTakenBy = window.localStorage['superClientId']
    else if (window.localStorage['ccdetails']) {
      let ccdetails = JSON.parse(atob(window.localStorage['ccdetails']))
      surveyTakenBy = ccdetails.cnuseraccid
    }
    return this.apiService.post(`/api/v2/survey/savesurveyresult`, { resultJson: result, surveyJson: question, patSwfId: swfid, mode, surveyTakenBy, type })
      .map(data => data);
  }
  partialsurvey(id, result, swfid, surveymode) {
    let surveyTakenBy = this.getCurrentUser().item.userAccountId
    if (window.localStorage['superClientId'])
      surveyTakenBy = window.localStorage['superClientId']
    else if (window.localStorage['ccdetails']) {
      let ccdetails = JSON.parse(atob(window.localStorage['ccdetails']))
      surveyTakenBy = ccdetails.cnuseraccid
    }
    return this.apiService.post(`/api/v2/survey/savepartialsurveyresult`, { patientSurveyMappingId: id, resultJson: result, patSwfId: swfid, surveyMode: surveymode, surveyTakenBy: surveyTakenBy })
      .map(data => data);
  }
  getCategory(obj) {
    let data = this.encrypt(JSON.stringify(obj))
    return this.apiService.post('/api/v2/todo/clickTodoListByCategoryId', { data })
      .map(data => this.decrypt(data.data));
  }
  getiddata(catId, userid, cnID) {
    let arg = {
      'todoCategoryId': catId,
      'loginUaId': userid,
      'selectedCnUaId': cnID
    }
    let data = this.encrypt(JSON.stringify(arg))
    return this.apiService.post('/api/v2/todo/clickCompletedTodoListByCategoryId', { data })
      .map(data => this.decrypt(data.data));
  }




  getAboutme() {
    return this.apiService.get('/api/v2/patient/getprofilequestions')
      .map(data => this.decrypt(data.data));
  }
  saveaboutme(data) {
    return this.apiService.post('/api/v2/patient/updateprofilequestions', data)
      .map(data => data);
  }
  getmessagedetails(patientSwfId) {
    return this.apiService.post('/api/v2/message/fetchPatientWithMessages', { patientSwfId })
      .map(data => data);
  }


  getPatprofile() {
    return this.apiService.get('/api/v2/patient/profile')
      .map(data => this.decrypt(data.data));
  }

  updpat(profile) {
    let data = this.encrypt(JSON.stringify(profile));
    return this.apiService.post(`/api/v2/patient/updateProfile`, { data })
      .map(data => this.decrypt(data.data));

  }

  sendsms(data) {
    return this.apiService.post('/api/v2/message/createNewMessage', data).map(data => data);
  }

  updatecarpa(id, patid, data) {
    data.userAccountId = id
    data.patientSwfId = patid
    return this.apiService.post(`/api/v2/patient/updatecarepartner`, data)
      .map(data => data);
  }

  // updatescore(painlevel, difflevel) {
  //   return this.apiService.post('/api/v2/patient/patient/updatescore?patientSWFId=' + window.localStorage['Puser'] + '&painLevel=' + painlevel + '&difficultyLevel=' + difflevel)
  //     .map(data => data);
  // }

  fgotdetails(emailId) {
    let data: any = {
      emailId: emailId
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/resetpassword', { data })
      .map(data => this.decrypt(data.data));
  }
  forgotUserInfo(userName) {
    let data: any = {
      userName: userName
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/getForgotPasswordInfo', { data })
      .map(data => this.decrypt(data.data));
  }
  // getreport() {
  //   return this.apiService.post('/api/v2/patient/patient/report?patientSWFId=' + window.localStorage['Puser'])
  //     .map(data => data);
  // }

  getrandomidcheck(randId) {
    return this.apiService.post('/api/validateuserbyrandid', { randId })
      .map(data => data);
  }

  chagepassword(pass, uid) {
    let arg = {
      userAccountId: uid,
      oldPassword: btoa(pass.oldPassword),
      newPassword: btoa(pass.newPassword),
      confirmPassword: btoa(pass.confirmPassword)
    }
    let data = this.encrypt(JSON.stringify(arg))
    return this.apiService.post('/changepassword', { data })
      .map(data => this.decrypt(data.data));
  }

  getactivity(swfid) {
    let data: any = {
      "patientSwfId": swfid
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/patient/activityboard', { data })
      // .map(data => data);
  }
  getpdf(url) {
    return this.apiService.postpdf('/api/v2/care/docHtml', url)
      // .map(data => data);
  }
  fetchCkChForPatDisclaimer(type, HspPatientMappingId) {
    let data: any = {
      "materialType": type,
      "patientSurveyMappingId": HspPatientMappingId
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/commonctrl/api/fetchCkChForPatDisclaimer', { data })
      .map(data => this.decrypt(data.data));
  }

  getcarepath(patswfid) {
    let data: any = {
      "patientSwfId": patswfid
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/patient/carepath', { data })
      // .map(data => this.decrypt(data.data));
  }
  updatesurvey(mappingid, type) {
    let Puser
    let auditData, carePartnerId;
    this.currentUser.subscribe(data => {
      auditData = data;
    });
    this.PUser.subscribe(data => {
      Puser = data;
    });
    if (auditData.item.carePartnerPatientName)
      carePartnerId = auditData.item.userAccountId
    let ccdetails
    if (window.localStorage['ccdetails'])
      ccdetails = JSON.parse(atob(window.localStorage['ccdetails']))
    else {
      ccdetails = {
        'cnuseraccid': carePartnerId ? carePartnerId : Puser.patientId ? Puser.patientId : '0'
      }
    }
    let arg = {
      'type': type,
      'mappingId': mappingid,
      'superClientId': window.localStorage['superClientId'] ? window.localStorage['superClientId'] : ccdetails.cnuseraccid
    }
    return this.apiService.post('/api/v2/patient/updatereviewstatus', arg)
      .map(data => data);
  }

  patientVideoMapId(mappingid, type) {
    let data: any = {
      "patientVideoMapId": mappingid,
      "type": type
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/patient/updateVideoStatus', { data })
      .map(data => data);
  }
  getpcarefamily(swfid, cid) {
    let data: any = {
      "patientSwfId": swfid,
      "loginUaId": cid
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/patient/carefamily', { data })
      .map(data => this.decrypt(data.data));
  }
  getcarepartner(id, patid) {
    let arg = {
      'userId': id,
      'patientId': patid
    }
    let data = this.encrypt(JSON.stringify(arg))
    return this.apiService.post('/api/v2/patient/carepartnerlist', { data })
      .map(data => this.decrypt(data.data));
  }
  getcarepartnerdetails(useraccid, patid) {
    let arg = {
      userAccountId: useraccid,
      patientId: patid
    }
    return this.apiService.post('/api/v2/patient/carepartnerdetails', arg)
      .map(data => data);
  }
  getip(): Observable<any> {
    let self = this;
    return self.apiService.get(`/getIpCaptureByUsers`)
      .map(data => data)
  }
  getappointment(patientSwfId) {
    let data: any = {
      "patientSwfId": patientSwfId
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/patient/appointments', { data })
      .map(data => this.decrypt(data.data));
  }

  getBmi(patientSwfId) {
    return this.apiService.post('/api/v2/cc/dashboard/fetchBMI', { patientSwfId })
      .map(data => data);
  }
  getmessages(swfid, cid) {
    let arg = {
      'patientSwfId': swfid,
      'loginUaId': cid
    }
    let data = this.encrypt(JSON.stringify(arg))
    return this.apiService.post('/api/v2/patient/getmessages', { data })
      .map(data => this.decrypt(data.data));
  }
  getbulletinboard(type) {
    return this.apiService.post('/api/v2/care/bulletinBoard', { type })
      .map(data => data);
  }
  getbulletindashboard(type, swfid) {
    let data: any = {
      "type": type,
      "patientSwfId": swfid
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/care/bulletinBoardByPatientswf', { data })
      // .map(data => this.decrypt(data.data));
  }

  getHTMLContent(url) {
    return this.apiService.getHTML(url).map(data => data);
  }
  getAll(): Observable<[string]> {
    return this.apiService.get('/api/user/listallusers')
      .map(data => data);
  }
  getclient(clientcode: any): Observable<[string]> {
    let data: any = {
      clientcode: clientcode
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/plogin', { data })
      .map(data => this.decrypt(data.data));
  }
  getAllgroup(): Observable<[string]> {
    return this.apiService.get('/api/user/usergroup')
      .map(data => data);
  }
  getAlluserprevilage(): Observable<[string]> {
    return this.apiService.get('/api/user/usergrouppriviledge')
      .map(data => data);
  }
  getAlluserprofile(): Observable<[string]> {
    return this.apiService.get('/api/user/userprofile')
      .map(data => data);
  }
  getassignedbydetails(mapid, type): Observable<[string]> {
    let data: any = {
      "patientSwfId": window.localStorage['Puser'],
      "materialId": mapid,
      "type": type
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/survey/getassignedbydetails', { data })
      .map(data => this.decrypt(data.data));
  }
  updatepasschange(rand, newpa, newpass) {
    let data = {
      "randId": rand,
      "pass": encodeURIComponent(newpa),
      "confPass": encodeURIComponent(newpass)
    }
    return this.apiService.post('/api/updatenewpassword', data)
      .map(data => data);
  }

  getranidcheck(randId) {
    return this.apiService.post('/api/validateuserbyrandid', { randId })
      .map(data => data);
  }
  getclientlogo(randId) {
    let data: any = {
      randId: randId
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/onboard/getPatientWelcomeInfo', { randId })
      .map(data => this.decrypt(data.data));
  }
  getresetpass(pass) {
    return this.apiService.put('/api/updatePasswordForForgotPassword', pass)
      .map(data => data);
  }
  setPath(currentuser) {
    if (currentuser.item.landingPage == 'CC_TO_DO' || currentuser.item.userGroupId == 32 || currentuser.item.userGroupId == 33) {

      this.router.navigateByUrl('/care/mytodo')
    } else if (currentuser.item.landingPage == 'AD_PATIENTQUALIFICATION') {

      this.router.navigateByUrl('/care/patientqualification')

    }
    else if (currentuser.item.userGroupId == 30 || currentuser.item.userGroupId == 31 || currentuser.item.userGroupId == 34) {
      this.router.navigateByUrl('/care/addpatient')
    }
    else {
      this.router.navigateByUrl('/care/patientlist')
    }
  }
  setPatientAuth(user: User, workflowId) {
    // Save JWT sent from server in localstorage
    this.jwtService.saveToken(user.item.token);
    this.getsession().subscribe(
      data => {
        if (data.item) {
          // if(data.item && data.item?.preferredLanguage !== this.selectedLang()) {      //for maintain CN pref language
          //   this.setCurrentLanguage(data.item?.preferredLanguage);
          // }
          if (data.item.purl)
            window.localStorage['plogin'] = data.item.purl
          this.currentUserSubject.next(data);
          if (user.item.patientId) {
            window.localStorage['patientId'] = user.item.patientId
          }
        }
        else {
          this.purgeAuth()
          this.router.navigateByUrl('/login')
        }
      }
    );
    // Set isAuthenticated to true
    this.isAuthenticatedSubject.next(true);
    this.idle = this.sessionService.getIdleObject();
    this.idle.watch();
    if (user.item.appRoles == "PRACTICE" || user.item.appRoles == "HOSPITAL") {
      /* this.getDetailsBasedOnRoleList(user.item.userAccountId,'0') */
      this.session()
      /* this.getDetailsBasedOnRoleList(user.item.userAccountId,'0') */
      this.getsession().subscribe(
        data => {
          let currentuser = data
          // if((data.item.availSecurity == true) && (data.item.welcomeFlag == true))
          if (data.item.availSecurity) {
            this.getip().subscribe(
              data => {
                if (data.usersIPCaptureDetails == "") {
                  this.router.navigateByUrl('/security/recovery')
                }
                else {
                  this.ipaddress = data.usersIPCaptureDetails[0].SameIPInFuture;
                  if ((this.ipaddress) && (!data.welcomeFlag || data.welcomeFlag)) {
                    this.ip1 = data.IpAddressCap;
                    this.ip2 = data.usersIPCaptureDetails[0].IpAddress
                    if (this.ip1 == this.ip2) {

                      if (currentuser.item.landingPage == 'CC_TO_DO' || currentuser.item.userGroupId == 32 || currentuser.item.userGroupId == 33) {

                        this.router.navigateByUrl('/care/mytodo')

                      } else if (currentuser.item.landingPage == 'AD_PATIENTQUALIFICATION') {

                        this.router.navigateByUrl('/care/patientqualification')

                      }
                      else if (currentuser.item.userGroupId == 30 || currentuser.item.userGroupId == 31 || currentuser.item.userGroupId == 34) {
                        this.router.navigateByUrl('/care/addpatient')
                      }
                      else {
                        this.router.navigateByUrl('/care/patientlist')
                      }
                      //this.router.navigateByUrl('/security/recovery')
                    }
                    else {
                      this.router.navigateByUrl('/security/recovery')
                    }
                  }
                  else {
                    this.router.navigateByUrl('/security/recovery')
                    return
                  }

                  // else if(this.ipaddress){
                  //   this.router.navigateByUrl('/care/mytodo')
                  //   return

                  // }
                }
              }
            );
          }
          else if ((data.item.availSecurity && !data.item.welcomeFlag) || (!data.item.availSecurity && !data.item.welcomeFlag)) {
            this.setPath(currentuser)
          }

          else if ((!data.item.availSecurity) && (data.item.welcomeFlag)) {


            if (currentuser.item.landingPage == 'CC_TO_DO' || currentuser.item.userGroupId == 32 || currentuser.item.userGroupId == 33) {

              this.router.navigateByUrl('/care/mytodo')

            } else if (currentuser.item.landingPage == 'AD_PATIENTQUALIFICATION') {

              this.router.navigateByUrl('/care/patientqualification')

            }
            else if (currentuser.item.userGroupId == 30 || currentuser.item.userGroupId == 31 || currentuser.item.userGroupId == 34) {
              this.router.navigateByUrl('/care/addpatient')
            }
            else {
              this.router.navigateByUrl('/care/patientlist')
            }
          }
        }
      )
      // this.router.navigateByUrl('/recovery')
    }
    else if (user.item.appRoles == "SURGEON") {
      /* this.getDetailsBasedOnRoleList(user.item.userAccountId,'0') */
      this.session()
      /* this.getDetailsBasedOnRoleList(user.item.userAccountId,'0') */
      this.getsession().subscribe(
        data => {
          let currentuser = data
          if (data.item.availSecurity) {
            this.getip().subscribe(
              data => {
                if (data.usersIPCaptureDetails == "") {
                  this.router.navigateByUrl('/security/recovery')
                }
                else {
                  this.ipaddress = data.usersIPCaptureDetails[0].SameIPInFuture;
                  if (this.ipaddress) {
                    this.ip1 = data.IpAddressCap;
                    this.ip2 = data.usersIPCaptureDetails[0].IpAddress
                    if (this.ip1 == this.ip2) {
                      //this.router.navigateByUrl('/security/recovery')
                      if (currentuser.item.landingPage == 'CC_TO_DO' || currentuser.item.userGroupId == 32 || currentuser.item.userGroupId == 33) {
                        this.router.navigateByUrl('/care/mytodo')
                      }
                      else if (currentuser.item.userGroupId == 30 || currentuser.item.userGroupId == 31 || currentuser.item.userGroupId == 34) {
                        this.router.navigateByUrl('/care/addpatient')
                      }
                      else {
                        this.router.navigateByUrl('/care/patientlist')
                      }
                    }
                    else {
                      this.router.navigateByUrl('/security/recovery')
                    }
                  }
                  else {
                    this.router.navigateByUrl('/security/recovery')
                    return
                  }
                  // else if(this.ipaddress){
                  //   this.router.navigateByUrl('/care/mytodo')
                  //   return
                  // }
                }
              }
            );
          }
          else {
            if (currentuser.item.landingPage == 'CC_TO_DO' || currentuser.item.userGroupId == 32 || currentuser.item.userGroupId == 33) {
              this.router.navigateByUrl('/care/mytodo')
            }
            else if (currentuser.item.userGroupId == 30 || currentuser.item.userGroupId == 31 || currentuser.item.userGroupId == 34) {
              this.router.navigateByUrl('/care/addpatient')
            }
            else {
              this.router.navigateByUrl('/care/patientlist')
            }
          }
        }
      )
      // this.router.navigateByUrl('/recovery')
    }
    else if (user.item.appRoles == "PATIENT") {
      this.postuserinfoid('0', user.item.userAccountId).subscribe(
        data => {
          for (var i = 0; i < data.length; i++) {
            /* this.getDetailsBasedOnRoleList(user.item.userAccountId,'0') */
            this.session()
            if (data[0].patientStageWorkflow.length) {
              let index = _.findIndex(data[0].patientStageWorkflow, function (o: any) { return o.patSWFId == workflowId; });
              if (index != -1) {
                this.setUser(data[0].patientStageWorkflow[index]);
                this.router.navigateByUrl('/patient/dashboard')
              }
              else {
                this.router.navigateByUrl('/loginasmode')
              }
            }
            else {
              this.router.navigateByUrl('/loginasmode')
            }
          }
        }
      );
    }
    else if (user.item.appRoles == "SOLVEDGE") {
      this.router.navigateByUrl('/admin')
    }
    else if (user.item.appRoles == "CSR") {
      this.router.navigateByUrl('/admin')
    }
  }

  setsurveyAuth(user: User, workflowId, surveymapid, surveytitle, surveyid) {
    // Save JWT sent from server in localstorage
    this.jwtService.saveToken(user.item.token);

    // Set current user data into observable
    this.currentUserSubject.next(user);
    // Set isAuthenticated to true
    this.isAuthenticatedSubject.next(true);
    this.idle = this.sessionService.getIdleObject();
    this.idle.watch();
    if (user.item.appRoles == "PRACTICE" || user.item.appRoles == "HOSPITAL") {

      /* this.getDetailsBasedOnRoleList(user.item.userAccountId,'0') */
      this.session()
      this.router.navigateByUrl('/care/patientlist')
    }
    else if (user.item.appRoles == "PATIENT") {
      this.postuserinfoid('1', user.item.userAccountId).subscribe(
        data => {
          for (var i = 0; i < data.length; i++) {
            /* this.getDetailsBasedOnRoleList(user.item.userAccountId,'0') */
            this.session()
            if (data[0].patientStageWorkflow.length) {
              let index = _.findIndex(data[0].patientStageWorkflow, function (o: any) { return o.patSWFId == workflowId; });
              if (index != -1) {
                this.setUser(data[0].patientStageWorkflow[index]);
                this.getcarepath(window.localStorage['Puser']).subscribe(
                  data => {
                    let surveform = data;
                    let id = _.filter(surveform, function (o: any) { return o.patientSveryMappingId == surveymapid; });
                    // //////console.log(id)
                    this.router.navigateByUrl('/patient/assessment/' + surveymapid + '/' + surveytitle + '/' + id[0].ID)
                  });
              } else {
                this.router.navigateByUrl('/loginasmode')
              }
            }
            else {
              this.router.navigateByUrl('/loginasmode')
            }
          }
        }
      );
    }
    else if (user.item.appRoles == "SOLVEDGE") {
      this.router.navigateByUrl('/admin')
    }
    else if (user.item.appRoles == "CSR") {
      this.router.navigateByUrl('/admin')
    }
  }

  setAsUser(Puser: Puser, user: User) {
    // Set current user data into observable
    this.currentUserSubject.next(user);
    this.PUserSubject.next(Puser);
    this.jwtService.saveworkflow(Puser.patSWFId);
    this.router.navigateByUrl('/patient/dashboard')
  }

  setTempVar(temp: any) {
    this.tempVarSubject.next(temp);
  }

  setAuth(user: User) {
    window.localStorage.removeItem('status');
    window.localStorage.removeItem('logopath');
    this.jwtService.saveToken(user.item.token);
    this.currentUserSubject.next(user);
    this.isAuthenticatedSubject.next(true);
    this.idle = this.sessionService.getIdleObject();
    this.idle.watch();
    if (!window.localStorage['patientId'] && user.item.patientId && !this.userModeStatus) {
      window.localStorage['patientId'] = user.item.patientId
    }
    this.getsession().subscribe(
      data => {
        if (data.item) {
          this.currentUserSubject.next(data);
          if (data.item.irrelevantAnswer && !this.userModeStatus) {
            let timeOut = environment.timelimit;
            this.toast.info(this.translateText('patient_portal.display_messages.security_answer_irrelevant'), '', {
              timeOut: timeOut
            })
          }
          if (data.item.securityAnswerEmpty && !window.localStorage['stykerAdminUser'] && !window.localStorage['ccdetails']) {
            this.router.navigateByUrl('/securityques')
            return;
          } else if ((data.item.passwordExpired || data.item.tempPasswordActive || data.item.credResetRequired) && !this.resetPassvalue && !window.localStorage['stykerAdminUser'] && !window.localStorage['ccdetails']) {
            this.router.navigateByUrl('/restpass')
            return;
          } else if (user.item.superClient || (user.item.demoSite && user.item.allowOnboard)) {
            this.router.navigateByUrl('/Demoportal')
            return
          } else if (this.userModeStatus) {
            this.router.navigateByUrl('/loginasmode')
            this.muliRoleEnter = false;
          } else {
            this.setLandingPage(data)
          }
          return;
        }
      }
    )
    this.muliRoleEnter = false;
    this.jwtService.destroymail()
    /* this.selectedWorkFlowID = 0; */
  }

  session() {
    this.getsession().subscribe(
      data => {
        if (data.item) {
          if (data.item.purl)
            window.localStorage['plogin'] = data.item.purl
          this.currentUserSubject.next(data);
        }
        else {
          this.purgeAuth()
          this.router.navigateByUrl('/login')
        }
      }
    );
  }

  setCCLanding(currentuser) {
    if (currentuser.item.landingPage == 'CC_TO_DO' || currentuser.item.userGroupId == 32 || currentuser.item.userGroupId == 33) {
      this.router.navigateByUrl('/care/mytodo')
    } else if (currentuser.item.landingPage == 'AD_PATIENTQUALIFICATION' && !currentuser.item.securityAnswerEmpty) {
      this.router.navigateByUrl('/care/patientqualification')
    }
    else if ((currentuser.item.userGroupId == 30 || currentuser.item.userGroupId == 31 || currentuser.item.userGroupId == 34) && !currentuser.item.securityAnswerEmpty) {
      this.router.navigateByUrl('/care/addpatient')
    }
    else {
      this.router.navigateByUrl('/care/patientlist')
    }
  }

  setLandingPage(user) {
    if (user.item.availSecurity) {
      this.getip().subscribe(
        data => {
          if (data.usersIPCaptureDetails == "") {
            this.router.navigateByUrl('/security/recoverypat')
          }
          else {
            this.ipaddress = data.usersIPCaptureDetails[0].SameIPInFuture;
            if (this.ipaddress) {
              this.ip1 = data.IpAddressCap;
              this.ip2 = data.usersIPCaptureDetails[0].IpAddress
              if (this.ip1 == this.ip2) {
                if (user.item.appRoles == "PRACTICE" || user.item.appRoles == "HOSPITAL" || user.item.appRoles == "SURGEON") {
                  this.setCCLanding(user)
                } else {
                  this.router.navigateByUrl('/patient/dashboard')
                }
                return
              }
              else {
                this.router.navigateByUrl('/security/recoverypat')
                return
              }
            }
            else {
              this.router.navigateByUrl('/security/recoverypat')
              return
            }
          }
        }
      );
    }
    else if (user.item.appRoles == "PRACTICE" || user.item.appRoles == "HOSPITAL" || user.item.appRoles == "SURGEON") {
      this.setCCLanding(user)
    }
    else if (user.item.appRoles == "PATIENT") {
      this.postuserinfoid('1', user.item.userAccountId).subscribe(
        data => {
          if (data && data.length > 0 && data[0].patientStageWorkflow.length == 1) {
            this.setUser(data[0].patientStageWorkflow[0]);
            this.router.navigateByUrl('/patient/dashboard');
          } else if (this.selectedWorkFlowID > 0) {
            this.AssignWorkFlowAndRedirectId(data);
          }
          else {
            this.router.navigateByUrl('/loginasmode');
          }
        }
      );
    }
    else {
      this.toast.info(this.translateText('patient_portal.display_messages.invalid_credentails'), '', {
        timeOut: 3000
      })
      this.router.navigateByUrl('/login')
    }
  }


  tempWorkFlowObject: any;
  AssignWorkFlowAndRedirectId(patWorkflowData) {
    for (var i = 0; i < patWorkflowData[0].patientStageWorkflow.length; i++) {
      if (patWorkflowData[0].patientStageWorkflow[i].patSWFId == this.selectedWorkFlowID) {
        this.tempWorkFlowObject = patWorkflowData[0].patientStageWorkflow[i];
        break;
      }
    }
    this.setUser(this.tempWorkFlowObject);
    this.selectedWorkFlowID = 0;
    this.router.navigateByUrl('/patient/dashboard');
  }



  setSAuth(user: User) {


    // Save JWT sent from server in localstorage
    this.jwtService.saveToken(user.item.token);

    // Set current user data into observable
    this.currentUserSubject.next(user);
    // Set isAuthenticated to true
    this.isAuthenticatedSubject.next(true);
    this.idle = this.sessionService.getIdleObject();
    this.idle.watch();
    if (user.item.appRoles == "PRACTICE" || user.item.appRoles == "HOSPITAL") {
      this.session()
      // if(user.item.demoSite && user.item.superClient){
      //   this.router.navigateByUrl('/Demoportal')
      // }
      // else
      this.router.navigateByUrl('/care/mytodo')


    }
    else if (user.item.appRoles == "PATIENT") {
      if (window.localStorage['Puser']) {
        this.getusersession()
          .subscribe(
            data => {
              this.setUser(data[0].patientStageWorkflow[0]);

            },
            err => this.purgeAuth()
          );
      }
      else {
        this.router.navigateByUrl('/loginasmode')
      }
    }
    else if (user.item.appRoles == "SOLVEDGE") {
      this.router.navigateByUrl('/admin')
    }
    else if (user.item.appRoles == "CSR") {
      this.router.navigateByUrl('/admin')
    }
  }
  setProfileAuth() {
    // Save JWT sent from server in localstorage
    this.isAuthenticatedSubject.next(true);
    this.getsession().subscribe(
      data => {
        let user = data
        // Save JWT sent from server in localstorage
        this.jwtService.saveToken(user.item.token);

        // Set current user data into observable
        this.currentUserSubject.next(user);
        // Set isAuthenticated to true
        this.isAuthenticatedSubject.next(true);
        this.idle = this.sessionService.getIdleObject();
        this.idle.watch();

        if (user.item.appRoles == "PRACTICE" || user.item.appRoles == "HOSPITAL") {
          //this.router.navigateByUrl('/care/mytodo')

        }
        else if (user.item.appRoles == "SURGEON") {
          //this.router.navigateByUrl('/care/mytodo')

        }
        else if (user.item.appRoles == "PATIENT") {
          if (window.localStorage['Puser']) {
            this.getusersession()
              .subscribe(
                data => {
                  this.setUser(data[0].patientStageWorkflow[0]);

                },
                err => this.purgeAuth()
              );
          }
          else {
            this.purgeAuth()
            this.router.navigateByUrl('/login')
          }
        }
      }
    )
  }

  setPAuth(user: User) {
    // Save JWT sent from server in localstorage
    this.jwtService.saveToken(user.item.token);

    // Set current user data into observable
    this.currentUserSubject.next(user);
    // Set isAuthenticated to true
    this.isAuthenticatedSubject.next(true);
    this.getsession().subscribe(
      data => {
        user = data
        // Save JWT sent from server in localstorage
        this.jwtService.saveToken(user.item.token);

        // Set current user data into observable
        this.currentUserSubject.next(user);
        // Set isAuthenticated to true
        this.isAuthenticatedSubject.next(true);
        this.idle = this.sessionService.getIdleObject();
        this.idle.watch();
        if (data.item.securityAnswerEmpty && !window.localStorage['stykerAdminUser'] && !window.localStorage['ccdetails']) {
          this.router.navigateByUrl('/securityques')
          return;
        } else if ((data.item.passwordExpired || data.item.tempPasswordActive || data.item.credResetRequired) && !this.resetPassvalue && !window.localStorage['stykerAdminUser'] && !window.localStorage['ccdetails']) {
          this.router.navigateByUrl('/restpass')
          return;
        } else if (user.item.superClient || (user.item.demoSite && user.item.allowOnboard)) {
          this.router.navigateByUrl('/Demoportal')
          return
        } else if (this.userModeStatus) {
          this.router.navigateByUrl('/loginasmode')
          this.muliRoleEnter = false;
        }
        else if (user.item.appRoles == "SURGEON" || user.item.appRoles == "PRACTICE" || user.item.appRoles == "HOSPITAL") {
          this.setCCLanding(user)

        }
        // else if (user.item.appRoles == "SURGEON") {
        //   this.router.navigateByUrl('/care/mytodo')

        // }
        else if (user.item.appRoles == "PATIENT") {
          if (window.localStorage['Puser']) {
            this.getusersession().subscribe(
              data => {
                this.setUser(data[0].patientStageWorkflow[0]);
              },
              err => this.purgeAuth()
            );
          }
          else {
            this.purgeAuth()
            this.router.navigateByUrl('/login')
          }
        }
      }
    )
  }

  setUser(Puser: Puser) {
    // Set current user data into observable
    this.PUserSubject.next(Puser);
    this.jwtService.saveworkflow(Puser.patSWFId);
    if (Puser.firstLogin) {
      this.setfirstlogin();
    }
  }

  setfirstlogin() {
    let patientSwfId = window.localStorage['Puser']
    this.apiService.post('/updatefirstlogin', { patientSwfId })
      .subscribe(
        data => data);
  }

  purgeAuth() {
    // Remove JWT from localstorage
    this.jwtService.destroyToken();
    this.jwtService.destroymail();
    // Set current user to an empty object
    this.currentUserSubject.next(new User());
    this.PUserSubject.next(new Puser());
    this.tempVarSubject.next('');
    this.jwtService.destroyworkflow();
    // Set auth status to false
    this.isAuthenticatedSubject.next(false);
    window.localStorage.removeItem('WFD');
    window.localStorage.removeItem('officeUser');
    window.localStorage.removeItem('userModeFlag');
    window.localStorage.removeItem('startdate');
    window.localStorage.removeItem('enddate');
    window.localStorage.removeItem('patientId');
    window.localStorage.removeItem('cnId');
    window.localStorage.removeItem('patientId');
    window.localStorage.removeItem('patSWFId');
    window.localStorage.removeItem('ccname')
    window.localStorage.removeItem('ccdetails')
    window.localStorage.removeItem('startdate');
    window.localStorage.removeItem('enddate');
    window.localStorage.removeItem('alltodoFilter')
    window.localStorage.removeItem('completedFilter')
    window.localStorage.removeItem('gcpFilter')
    window.localStorage.removeItem('gcpCompletedFilter')
    window.localStorage.removeItem('thdFilter')
    window.localStorage.removeItem('thdCompletedFilter')
    window.localStorage.removeItem('followupFilter')
    window.localStorage.removeItem('followUpCompletedFitler')
    window.localStorage.removeItem('vnsFilter')
    window.localStorage.removeItem('vnsCompletedFilter')
    window.localStorage.removeItem('patFilter')
    window.localStorage.removeItem('LLD')
    window.localStorage.removeItem('appoinmentFilter')
    window.localStorage.removeItem('setBugetFilter');
    window.localStorage.removeItem('superClientId');
    window.localStorage.removeItem('stykerAdminUser');
    window.localStorage.removeItem('adminnamefname');
    window.localStorage.removeItem('adminnamelname');
    window.localStorage.removeItem('onboradingCP');
    window.localStorage.removeItem('patpwd');
    window.localStorage.removeItem('pwd');
    window.localStorage.removeItem('completed');
    window.localStorage.removeItem('maintainCareList');
    window.localStorage.removeItem('maintainReassign');
    window.localStorage.removeItem('pdfPath');
    window.localStorage.removeItem('currentStageName');
    window.localStorage.removeItem('careDetails');
    window.localStorage.removeItem('surveyData');
    window.localStorage.removeItem('patDetails');
    window.localStorage.removeItem('viewsurveyData');
    window.localStorage.removeItem('careGiverDetails');
    window.localStorage.removeItem('assesDetails');
    window.localStorage.removeItem('careId');
    window.localStorage.removeItem('userMode');
    window.localStorage.removeItem('patDob');
    window.localStorage.removeItem('returnToOffice');
    this.muliRoleEnter = false
  }

  attemptPatientAuth(data, workflowId): Observable<User> {
    data['officeUser'] = data['officeUser'] == "" ? 0 : data['officeUser']
    data['switchPortal'] = 0;

    data = this.encrypt(JSON.stringify(data));
    return this.apiService.post('/api/authsession', { data }).map(
      data => {
        if (data) {
          data = this.decrypt(data.data)
          //this.purgeAuth();
          window.localStorage['LLD'] = data.item.lastLoginDate
          this.setPatientAuth(data, workflowId);
          return data;
        }
      }
    );
  }
  attemptProfileAuth(credentials): Observable<User> {
    credentials['officeUser'] = 0
    credentials['switchPortal'] = 0;
    credentials["language"]= this.selectedLang();
    return this.apiService.post('/api/authsession', credentials)
      .map(
        data => {
          if (data) {
            this.setPAuth(data);
            return data;
          }
        }
      );
  }
  checkCaptcha(userName) {
    let data = this.encrypt(JSON.stringify(userName))
    return this.apiService.post('/api/generateCaptcha', { data })
      .map(data => this.decrypt(data.data))
  }

  getLanguageConfig(userName) {
    return this.apiService.post('/getLanguageConfigByUser',  userName)
  }
  getMaterials(payload) {
    return this.apiService.post('/api/fetchLocaleFAQMaster',  payload)
  }

  saveMaterialsAudit(payload) {
    return this.apiService.post('/api/saveLocaleFAQAudit',  payload)
  }

  userModeStatus: boolean = false;
  attemptAuth(credentials): Observable<User> {
    credentials['officeUser'] = credentials['officeUser'] == "" || !credentials['officeUser'] ? 0 : credentials['officeUser']
    credentials['switchPortal'] = credentials['switchPortal'] == "" || !credentials['switchPortal'] ? 0 : credentials['switchPortal'];
    credentials["language"]= this.selectedLang();
    ///d
    let data = this.encrypt(JSON.stringify(credentials))
    return this.apiService.post('/api/authsession', { data }).map(
      data => {
        data = this.decrypt(data.data);
        // if(data?.item?.userGroupId && (data?.item?.userGroupId !== 19 && credentials["language"] !== this.cnDefaultLang)) {    //set english as default language
        //   this.setCurrentLanguage(this.cnDefaultLang);
        // }
        if (!data.sessionActive) {
          if (data.item.userMode?.toLowerCase() == "multi" && !this.muliRoleEnter && !window.localStorage['ccdetails']) {
            data.status = true;
            this.userModeStatus = true;
          } else {
            this.userModeStatus = false;
          }
          window.localStorage['LLD'] = data.item.lastLoginDate
          /*---------------- OC user redirection ------------------*/
          if (data.item.userAccountKey == 200287)//------------->oc user useraccountkey
          {
            this.ocRedirctFunction(data)
          }
          else {
            if(data.item.userGroupId!=19 && data.item.userGroupId!=20){
              if(!localStorage.getItem("returnToOffice"))
              { 
                this.jwtService.saveToken(data.item.token);
                this.fetchUserStatus(data.item.userAccountId)
                .subscribe( res => {
                  if(res?.outOfOfficeMasterId && res?.outOfOfficeMasterId == 1){
                    let from = new Date(res?.outOfOfficeFromDate).setHours(0, 0, 0, 0);
                    let to = new Date(res?.outOfOfficeToDate).setHours(0, 0, 0, 0);
                    let today = new Date().setHours(0, 0, 0, 0);

                    if(today >= from && today <= to) {
                      this.outOfOfficeStatus = res;
                      this.progressBarPopup = this.dialog.open(SessiontempComponent, {
                        hasBackdrop: true,
                        disableClose: true
                      });
                      this.progressBarPopup.componentInstance.showOutOfOffice = true;
                      this.progressBarPopup.componentInstance.userDetails = data?.item;
            
                      this.progressBarPopup.afterClosed().subscribe(result => {
                        if (result != '' && 'skip' == result) {
                          this.skipOfOffice(1, data);
                        } else if (result != '' && 'yes' == result) {
                          this.skipOfOffice(2, data);
                        }
                      });
                    } else this.setAuth(data);
                  } else this.setAuth(data);
                }, (error) => {
                  this.setAuth(data);
                });
              } else this.setAuth(data);
            } else 
              this.setAuth(data);
          }
        }
        return data;
      }
    );
  }

  skipOfOffice(statusId: number, data: any) {
    const payload = {
      userAccountId: data.item.userAccountId,
      outOfOfficeMasterId: statusId,   // 1 or 2
      outOfOfficeReason: this.outOfOfficeStatus?.outOfOfficeReason || null,
      outOfOfficeFromDate: this.fromDate ? new Date(this.fromDate).getTime() : null,
      outOfOfficeToDate: this.toDate ? new Date(this.toDate).getTime() : null,
      loginAttemptonooo: true
    };
  
  
    let timealert: any = environment.timelimit;
  
    this.RecordUserOutOfOfficeStatus(payload).subscribe(
      res => {
        if (res && res?.SUCCESS) {
          this.toast.success(res.SUCCESS, '', {
            timeOut: timealert
          });
  

          if (statusId === 2) {
            this.fromDate = null;
            this.toDate = null;
            this.outOfOfficeStatus = null;
            this.outOfOfficeReason = '';
          }
  
        } else {
          this.toast.error(
            res?.ERROR || (typeof res === 'string' ? res : JSON.stringify(res)),
            '',
            { timeOut: timealert }
          );
        }
  
        this.setAuth(data);
      },
      error => this.setAuth(data)
    );
  
    localStorage.setItem('returnToOffice', 'true');
  }
  

  // attemptSAuth(credentials): Observable<User> {
  //   credentials['officeUser'] = 0
  //   credentials['switchPortal'] = 0;
  //   credentials["language"]= this.selectedLang();

  //   return this.apiService.post('/api/authsession', credentials).map(
  //     data => {
  //       /*---------------- OC user redirection ------------------*/
  //       if (data.item.userAccountKey == 200287)//------------->oc user useraccountkey
  //       {
  //         this.ocRedirctFunction(data)
  //       }
  //       else {
  //         this.setAuth(data);
  //       }
  //       return data;
  //     }
  //   );
  // }

  sauth(sessionID, arguObj): Observable<User> {
    arguObj.tokenId = sessionID
    return this.apiService.post('/api/validateuserbyCASRCToken', arguObj)
      .map(data => data);
  }

  getReportURL() {
    return this.apiService.get('/api/v2/reports/GenerateRCReportToken')
      .map(data => data);
  }
  getOnboardURL() {
    return this.apiService.get('/api/v2/reports/GenerateTokenToAccessRcOnBoard')
      .map(data => data);
  }
  senttocken(Tokenidset) {
    return this.apiService.post('/api/validateTokenForRCOnBoardAccess', { Tokenidset })
      .map(data => data);
  }
  getCareList(userId, id) {
    let data: any = {
      "userAccountId": id,
      "practiceId": userId
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post(`/api/v2/care/getcnlist`, { data })
      .map(data => this.decrypt(data.data));
  }


  attemptsurveyAuth(credentials, workflowid, surveymapid, surveytitle, surveyid): Observable<User> {
    credentials['officeUser'] = 0
    credentials['switchPortal'] = 0;
    credentials["language"]= this.selectedLang();

    return this.apiService.post('/api/authsession', credentials).map(
      data => {
        this.setsurveyAuth(data, workflowid, surveymapid, surveytitle, surveyid);
        return data;
      }
    );
  }
  getPUser(): Puser {
    return this.PUserSubject.value;
  }

  getCurrentUser(): User {
    return this.currentUserSubject.value;
  }

  // Update the user on the server (email, pass, etc)
  update(user): Observable<User> {
    return this.apiService.put('/user/updateuserfnameandlname', user)
      .map(data => {
        this.setAuth(data);
        return data;
      });
  }
  updatepass(user): Observable<User> {
    return this.apiService.put('/user/updateuserpwd', user)
      .map(data => data);
  }
  userupdate(user, userid): Observable<User> {
    return this.apiService.put('/user/userupdate/' + userid, user)
      .map(data => data);
  }
  adduser(credentials): Observable<[User]> {
    return this.apiService.post('/user/useradd', credentials)
      .map(data => data);
  }
  addprofile(credentials): Observable<[User]> {
    return this.apiService.post('/user/createprofile', credentials)
      .map(data => data);
  }

  addcarefamily(addcarepartner): Observable<any> {
    return this.apiService.post('/api/v2/patient/addcarepartner', addcarepartner)
      .map(data => data);
  }
  addcarefamilyupdate(userId): Observable<User> {
    return this.apiService.put('/patient/updatecarepartner', userId)
      .map(data => data);
  }


  postgroup(credentials): Observable<string> {
    return this.apiService.post('/user/createusergroup', credentials)
      .map(data => data);
  }
  // Update the Client on the server
  updategroup(group, groupid): Observable<string> {
    return this.apiService.put('/user/updateusergroup/' + groupid, group)
      .map(data => data);
  }
  // Update the UserGroup Previlage on the server
  updategroupprevilage(groupprevilageid, groupprevilage): Observable<string> {
    return this.apiService.put('/user/updateusergrouppriviledge/' + groupprevilageid, groupprevilage)
      .map(data => data);
  }
  saveRemit(swfid, datas): Observable<string> {
    datas.patSwfId = swfid
    return this.apiService.post('/api/v2/patient/savePatientReadmission', datas)
      .map(data => data);
  }
  getReadmission(patswf): Observable<any> {
    let data: any = {
      "patientSwfId": patswf
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/patient/willReAdmissionBeShown', { data })
      .map(data => this.decrypt(data.data));
  }


  cheReadm(patswfid, datas): Observable<string> {
    datas.patSwfId = patswfid
    return this.apiService.post('/api/v2/patient/checkIfSameReadmissionExist', datas)
      .map(data => data);
  }


  // IPBlocked Service End Here
  getIPAccess() {
    return this.apiService.post('/api/ipcountryaccess').map(data => data);
  }

  getExcludeBundle(patientswfid) {
    let data: any = {
      "patientSwfId": patientswfid
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/patient/getBundleInfo', { data })
      .map(data => this.decrypt(data.data));
  }
  getdeletereasontype() {
    return this.apiService.get('/api/v2/patient/getDeleteReasonType')
      .map(data => data);
  }
  getAllHosp(patientswf) {
    let data = {
      "patSwfId": patientswf
    }
    return this.apiService.post('/api/v2/care/gethospitallist', data)
      .map(data => data);
  }
  getcheckmultipart(patientId) {
    return this.apiService.post('/api/v2/care/checkMultiBodyPartPatient', { patientId })
      .map(data => data);
  }
  getdeletepat(patientId, reason, cnuserid, patHospId) {
    let data: any = {
      "patientId": patientId,
      "reason": reason,
      "cNUserId": cnuserid,
      "hospitalId": patHospId
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post(`/api/v2/care/deletePatient`, { data })
      .map(data => data);
  }
  showappointment(key) {
    let data: any = {
      "hospitalId": key
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post(`/api/v2/appointment/isCustomAppmntConfigured`, { data })
      .map(data => this.decrypt(data.data));
  }
  ExcIncBPCIAPI(patientSwfId, excludeMyTodo, userAccountId, type, Cards, reasonbundle) {
    let arg = {
      'patientSwfId': patientSwfId,
      'bundleMytodo': excludeMyTodo,
      'userAccountId': userAccountId,
      'bundleCareCard': Cards,
      'reasonbundle': reasonbundle
    }
    let data = this.encrypt(JSON.stringify(arg))
    if (type == "exclude") {
      //  reasonbundle= reasonbundle.replace(/^"|"$/g, '') ;
      return this.apiService.post('/api/v2/cc/bundle/excludeBundle', { data }).map(data => data);
    } else {
      return this.apiService.post('/api/v2/cc/bundle/includeBundle', { data }).map(data => data);
    }
  }
  /*Edit patient - Include / ExcludeBundle  */
  getIncludeExcludeBundle(patientSwfIdValue) {
    let data: any = {
      "patientSwfId": patientSwfIdValue
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/care/getPatientDetails', { data })
      .map(data => this.decrypt(data.data));
  }

  /**** Patient Cotact Me Service Start Here ****/

  getContactMeClientDetailsID(clientid) {
    let data: any = {
      "clientId": clientid
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post(`/api/v2/adminPrivilege/getClientDetails`, { data })
      .map(data => this.decrypt(data.data))
  }

  getContactMeTemplate(clientid) {
    let data = {
      "clientId": atob(window.localStorage.getItem('WFD'))
    }
    return this.apiService.post('/api/v2/adminPrivilege/getContactustemplate', data)
  }

  getGeneralDocument() {
    return this.apiService.get(`/api/v2/adminPrivilege/getToolKitGeneralDocuments/`)
  }

  getToolkitCNDocument(clientId, clientType) {
    let data = {
      'clientType': clientType,
      'clientId': clientId
    }
    return this.apiService.post('/api/v2/adminPrivilege/getToolKitCNDocuments', data)
  }

  fetchDischargeLocationContacts(hospitalID, patientSWFID, dischargeType, dischargeTo) {
    let arg = {
      'hospitalId': hospitalID,
      'patientSwfId': patientSWFID,
      'dischargeType': dischargeType,
      'dischargeTo': dischargeTo
    }
    return this.apiService.post(`/api/v2/cc/dashboard/fetchDischargeLocationContacts`, arg)
  }

  saveDischargeLocationContacts(saveType, data) {

    data.forEach(obj => {
      obj.isAssignThis = saveType
    })

    return this.apiService.post(`/api/v2/cc/dashboard/saveDischargeLocationContacts`, data)
  }

  // fetchReadmissionDetails(patientSwfId, readmissionId) {
  //   return this.apiService.get(`/api/v2/cc/dashboard/fetchPatientDbReadmission/${patientSwfId}/${readmissionId}`)
  // }


  // saveReadmissionDetails(data): Observable<[User]> {
  //   return this.apiService.post(`/api/v2/cc/dashboard/savePatientDbReadmission`, data)
  //     .map(data => data);
  // }
  phonebycountrycode(data) {
    let value: any = {
      "countryCode": data
    }
    data = this.encrypt(JSON.stringify(value))
    return this.apiService.post('/api/v2/care/getphonebycountrycode', { data })
      .map(data => this.decrypt(data.data));
  }
  getUnsubscribe(userAccountId) {
    return this.apiService.servletpost('/pages/UnsubscribeEmail', { userAccountId })
      .map(data => data);
  }
  postUnsubscribe(userAccountId) {
    return this.apiService.servletpost('/pages/SaveUnsubscribeEmail', { userAccountId })
      .map(data => data);
  }

  RoleListByLoginUser(emailAddress, phoneNumber) {
    let arg = {
      'phoneNumber': phoneNumber,
      'emailId': emailAddress
    }
    let data = this.encrypt(JSON.stringify(arg))
    return this.apiService.post(`/api/v2/care/rolelistByloginuser`, { data })
      .map(data => this.decrypt(data.data));
  }

  getDetailsBasedOnRoleList(userAccountId, data) {
    data.tokenId = userAccountId
    return this.apiService.post('/api/getsessionformulti', data)
  }



  patientValidationWithDOB(dob, patientId, mappingId) {
    let arg = {
      'dob': dob,
      'patientId': patientId,
      'mappingid': mappingId
    }
    return this.apiService.post(`/api/v2/care/checkPatient`, arg)
  }

  getusersessionMulti(userAccountId) {
    let data: any = {
      'patientSwfId': window.localStorage['Puser'],
      'userAccountId': userAccountId
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/getUserSessionforMulti', { data })
      // .map(data => this.decrypt(data.data));

  }

  getDischargeMapByPractice(userAccountId) {
    let data: any = {
      "practiceId": userAccountId
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/care/getDischargeMapByPractice', { data })
      .map(data => this.decrypt(data.data));
  }

  /* Get security Question  */
  getSelectedQuestnListByUser(obj) {
    return this.apiService.post('/api/getSelectedQuestnListByUser', obj)
      .map(data => data);
  }

  /* Get security Question Wrong Attempt  */
  getSecurityQuesWrongCredentials(randId) {
    return this.apiService.post('/api/isAccountActiveORBlocked', { randId })
      .map(data => data);
  }


  /* Get validate Question  */
  validateSelectedQuestnAnsByUser(randId, secQuestionId, answer) {
    let data = {
      "randId": randId,
      "questionId": secQuestionId,
      "answer": answer
    }
    return this.apiService.post('/api/validateSelectedQuestnAnsByUser', data)
      .map(data => data);
  }
  /* Get  security Question  */
  getForgotSecurityQuesAnsLinkByUser(randId) {
    return this.apiService.post('/api/getForgotSecurityAnswerByUser', { randId })
      .map(data => data);
  }
  /* Get blocked user account  */
  // blockUserAccount(randId) {
  //   return this.apiService.get(`/api/blockUserAccountByWrongAnswer?randId=${randId}`)
  //     .map(data => data);
  // }
  /* Profile - saveSecurityQuestionsAndAnswers*/
  /* list  */
  getSecQuesAns(userid) {
    let data: any = {
      "userAccountId": userid
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/onboard/getSecQuesAns', { data })
      .map(data => this.decrypt(data.data));
  }
  /* save and Update  */
  saveSecQuesAns(userid, data) {
    data.userAccountId = userid
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/onboard/saveSecQuesAns', { data })
      .map(data => data);
  }




  /* CN Mapping  - Surgeon */
  getSurgeonList(userAccountId): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/care/fetchSurgeonList`, { userAccountId })
      .map(data => data)
  }
  /*Proceduretype */
  getProceduretypeList(userAccountKey): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/care/fetchServicelineByPracticeId`, { userAccountKey })
      .map(data => data)
  }
  /* PayorId */
  getPayorIdList(practiceId): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/care/fetchPayorTypeByPractice`, { practiceId })
      .map(data => data)
  }

  // InPatient Config

  getInPatientsConfig(userAccountKey, userAccountId): Observable<any> {
    let self = this;
    let data = {
      'hospitalId': userAccountKey,
      'loginUaId': userAccountId
    }
    return self.apiService.post(`/api/v2/care/getInOutpatientTodoCategoryList`, data)
      .map(data => data)
  }


  fetchCNSugProcPayer(surgeonId, procedureType, payorId, hospitalId) {
    let self = this;
    let data = {
      "surgeonId": surgeonId,
      "procedureType": procedureType,
      "payorId": payorId,
      "hospitalId": hospitalId
    }
    return self.apiService.post('/api/v2/care/fetchCNSugProcPayer', data)
      .map(data => data)
  }

  getValidationLink(randId) {
    let self = this;
    return self.apiService.post(`/api/v2/onboard/getValidationLink`, { randId })
      .map(data => data)
  }

  //Getting all client for styker
  getAllclientforStyker(param, id): Observable<[string]> {
    let obj = {
      'userAccountId': id,
      'mode': param
    }
    return this.apiService.post(`/api/v2/admin/hospital`, obj)
      .map(data => data)
  }


  //Getting all user for styker
  getUserListByHospital(hospitalId): Observable<any> {
    let self = this;
    return self.apiService.post('/api/v2/admin/getUsersByHospital', { hospitalId })
  }

  logAudit(category, bundlepid) {
    let auditData;
    this.currentUser.subscribe(data => {
      auditData = data;
    });

    let stykerId = window.localStorage['superClientId'] ? window.localStorage['superClientId'] : 0
    let patSwfId = window.localStorage['patSWFId'] ? JSON.parse(atob(window.localStorage['patSWFId'])) : 0
    let patId, cnId, hspId, carePartnerId = 0;
    if (auditData.item.appRoles != "PATIENT") {
      patId = window.localStorage['patientId'] ? window.localStorage['patientId'] : 0;
      cnId = auditData.item.userAccountId
      hspId = auditData.item.userAccountKey
    }
    else {
      let Puser
      this.PUser.subscribe(data => {
        Puser = data;
      });
      // 6025020
      let ccdetails;
      if (ccdetails) {
        ccdetails = JSON.parse(atob(window.localStorage['ccdetails']))
        cnId = ccdetails.cnuseraccid ? ccdetails.cnuseraccid : 0;
      } else {
        ccdetails = 0;
        cnId: 0;
      }
      patId = Puser.patientId ? Puser.patientId : 0
      hspId = auditData.item.userAccountKey ? auditData.item.userAccountKey : 0
      patSwfId = window.localStorage['Puser'] ? window.localStorage['Puser'] : 0
      if (auditData.item.carePartnerPatientName)
        carePartnerId = auditData.item.userAccountId

    }
    //var patswParse=window.localStorage['patSWFId'] ?JSON.parse(atob(window.localStorage['patSWFId'])):0
    const obj = {
      'adminId': stykerId,
      'category': category,
      'hspId': hspId,
      'cnID': cnId,
      'patId': patId,
      'patSwfId': patSwfId.patSWFId ? patSwfId.patSWFId : patSwfId,
      'carePartnerId': carePartnerId ? carePartnerId : 0,
      'bundlepid': bundlepid ? bundlepid : 0
    }
    let data = this.encrypt(JSON.stringify(obj))
    return this.apiService.post('/api/v2/care/saveuseraudit', { data })
      .map(data => data);
  }

  //Readmission Hospital for patient portal
  fetchHospitalListForReadmission(userAccountId) {
    let data = this.encrypt(JSON.stringify({ userAccountId }))
    return this.apiService.post('/api/v2/patient/fetchHospitalListForReadmission', { data })
      .map(data => this.decrypt(data.data));
  }

  UpdatePatientActivationDate(patientSwfId) {
    return this.apiService.post('/api/v2/onboard/UpdatePatientActivationDate', { patientSwfId })
      .map(data => data);
  }

  // Track External Embedded Link
  trackExternalEmbeddedLink(obj) {
    return this.apiService.post('/api/v2/care/api/trackExternalEmbeddedLink', obj)
      .map(data => data);
  }

  // Track External Embedded Link
  fetchAllMultipleCompletedSurveys(payload) {
    let data = this.encrypt(JSON.stringify(payload))
    return this.apiService.post('/api/v2/cc/dashboard/fetchAllMultipleCompletedSurveys', { data }).map(data => { return this.decrypt(data.data) });
  }
  fetchCompeletedSurveyList(obj) {
    let data = this.encrypt(JSON.stringify(obj))
    return this.apiService.post('/api/v2/cc/dashboard/fetchCompeletedSurveyList', { data }).map(data => { return this.decrypt(data.data) });
  }
  showExportSurvey(payload) {
    let data = this.encrypt(JSON.stringify(payload))
    return this.apiService.post('/api/v2/cc/dashboard/showExportSurvey', { data }).map(data => { return this.decrypt(data.data) });
  }
  // multipart pdf file
  savePatientDocument(file) {
    return this.apiService.multipartFileUpload('/api/v2/patientDocumentCtrl/savePatientDocument', file).map(data => { return this.decrypt(data.data) });
  }
  fetchAllPatientDocument(obj) {
    let data = this.encrypt(JSON.stringify(obj))
    return this.apiService.post('/api/v2/patientDocumentCtrl/fetchAllPatientDocument', { data }).map(data => { return this.decrypt(data.data) });
  }

  deletePatientDocument(obj) {
    let data = this.encrypt(JSON.stringify(obj))
    return this.apiService.post('/api/v2/patientDocumentCtrl/deletePatientDocument', { data }).map(data => { return this.decrypt(data.data) });
  }
  unReadTotalDocumentsCount(cid) {
    var payload: any = {
      "patientSwfId": Number(window.localStorage['Puser']),
      "loginUaId": cid
    }
    let data = this.encrypt(JSON.stringify(payload))
    return this.apiService.post('/api/v2/patientDocumentCtrl/unReadTotalDocumentsCount', { data }).map(data => { return this.decrypt(data.data) });
  }
  updateCountForPatientDocument(cid) {
    var payload: any = {
      "patientSwfId": Number(window.localStorage['Puser']),
      "loginUaId": cid
    }
    let data = this.encrypt(JSON.stringify(payload))
    return this.apiService.post('/api/v2/patientDocumentCtrl/updateCountForPatientDocument', { data }).map(data => { return this.decrypt(data.data) });
  }

  secretKey = CryptoJS.enc.Base64.parse("U29sdkVkZ2VLZXlAMTIzNA==");
  encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, this.secretKey, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
  }

  decrypt(textToDecrypt: string) {
    return JSON.parse(CryptoJS.AES.decrypt(textToDecrypt, this.secretKey, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8))
  }

  tempSurveyAssociationData: any
  saveTemporaryData(data) {
    this.tempSurveyAssociationData = data
  }

  getTemporaryData() {
    return this.tempSurveyAssociationData ? this.tempSurveyAssociationData : []
  }

  associationSurveyDataInActivityBoard: any = []
  checkForAssociateSurveyInActivityBoard(data: any) {
    this.associationSurveyDataInActivityBoard = []
    var count = -1
    for (var episode of data) {
      count += 1
      this.associationSurveyDataInActivityBoard.push({ 'episodeName': episode.episodeName, 'surveys': [] })
      for (var survey of episode.data) {
        if (survey.associateHsmId != null && survey.associateHsmId != 0) {
          var associateSurveyHospMappingId = survey.associateHsmId
          var theWholeEpisodesSurveys = episode.data
          for (var tailSurvey of theWholeEpisodesSurveys) {
            if (tailSurvey.hpsmId == associateSurveyHospMappingId) {
              this.associationSurveyDataInActivityBoard[count]['surveys'].push({ "Lead": survey, "Tail": tailSurvey })
            }
          }
        }
      }
    }
    this.saveTemporaryData(this.associationSurveyDataInActivityBoard)
    return this.associationSurveyDataInActivityBoard
  }

  associationSurveyDataInPatientDashboard: any = []
  checkForAssociateSurveyInPatientDashboard(data: any) {
    var dummy_arr = []
    this.associationSurveyDataInPatientDashboard = []
    for (var survey of data) {
      if (survey.associateHsmId != null && survey.associateHsmId != 0) {
        var associateSurveyHospMappingId = survey.associateHsmId
        var theWholeSurveys = data
        for (var tailSurvey of theWholeSurveys) {
          if (tailSurvey.hpsmId == associateSurveyHospMappingId) {
            console.log(survey, tailSurvey, "Survey!!")
            dummy_arr.push(tailSurvey.name.toLowerCase())
            this.associationSurveyDataInPatientDashboard.push({ "Lead": survey, "Tail": tailSurvey })
          }
        }
      }
    }
    this.saveTemporaryData(this.associationSurveyDataInPatientDashboard)
    return dummy_arr
  }

  attemptAuthFromOB(credentials): Observable<User> {
    credentials["language"]= this.selectedLang();

    let data = this.encrypt(JSON.stringify(credentials))
    return this.apiService.post('/api/authsession', { data })
      .map(
        data => {
          data = this.decrypt(data.data)
          if (!data.sessionActive) {
            if (data.item.userMode == "Multi" && !this.muliRoleEnter && !window.localStorage['ccdetails']) {
              data.status = true;
              this.userModeStatus = true;
            } else {
              this.userModeStatus = false;
            }
            window.localStorage['LLD'] = data.item.lastLoginDate
            /*---------------- OC user redirection ------------------*/
            if (data.item.userAccountKey == 200287)//------------->oc user useraccountkey
            {
              this.ocRedirctFunction(data)
            }
            else {
              this.setAuth(data);
            }
          }
          return data;
        }
      );
  }

  /****************************** Oc User redirection**************************************/
  progressBarPopup: MatDialogRef<SessiontempComponent>;
  ocRedirctFunction(user: User) {
    this.jwtService.saveToken(user.item.token);
    this.progressBarPopup = this.dialog.open(SessiontempComponent, { hasBackdrop: true, disableClose: true, data: {ocUser: true }});
    this.progressBarPopup.componentInstance.ocUser = true;
    this.progressBarPopup.afterClosed().subscribe(result => { this.logoutuser(user.item.userAccountId) });
  }

  setCurrentLanguage(language:string, subscribe=true) {
    this.defaultLang = language || this.cnDefaultLang;
    localStorage.setItem("selectedLanguage", this.defaultLang);
    this.translate.use(this.defaultLang).subscribe({
      next: () => {
        if(subscribe)
          this.languageFileLoadStatus(true);
      },
      error: (err) => {
        console.error(`Failed to load language '${language}'`, err);
      }
    });
  }

  languageFileLoadStatus(status: boolean) {
    this.langFileSubject.next(status);
  }

  RecordUserOutOfOfficeStatus(data) {
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/profile/recordUserOutOfOfficeStatus',  {data})
  }

 fetchUserStatus(userAccountId) {
    let data: any = {
      "userAccountId": userAccountId
    }
    data = this.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/profile/fetchUserOutOfOfficeStatus',  {data})
  }
  
  loadEmailPopup() {
    this.progressBarPopup = this.dialog.open(SessiontempComponent, {
      hasBackdrop: true,
      disableClose: true,
      width: '400px',   
      maxWidth: '70vw', 
    });
    this.progressBarPopup.componentInstance.showEmail = true;
    this.progressBarPopup.afterClosed().subscribe(result => {
      if(result !== '') {
        
      }
    });
  }
}
